import React from 'react';
import MobileCompletedActivitiesTable from 'App/features/WorkQueue/components/Tables/MobileCompletedActivitiesTable';

const AssignmentMobileCompletedActivityTable = () => {
    return <MobileCompletedActivitiesTable isAssignmentManager />;
};

export default AssignmentMobileCompletedActivityTable;
